import { render } from "./MobileGreenBox2.vue?vue&type=template&id=6848b888"
import script from "./MobileGreenBox2.vue?vue&type=script&lang=js"
export * from "./MobileGreenBox2.vue?vue&type=script&lang=js"

import "./MobileGreenBox2.vue?vue&type=style&index=0&id=6848b888&lang=css"

import exportComponent from "/home/runner/work/tre/tre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__